import { useState, useEffect } from 'react'
import { fetchGroupOrders } from '../utils/checklistSections'

// Ordem atual dos grupos de checklist ({ [groupId]: order }), buscada ao montar.
export default function useGroupOrders() {
    const [groupOrders, setGroupOrders] = useState({})
    useEffect(() => { fetchGroupOrders().then(setGroupOrders) }, [])
    return groupOrders
}
